import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import { Link } from "react-router-dom";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import * as actions from "../redux/actions/sessionActions";
import "./styles/RegisterSuccessfull.css";

class GodiwayActivate extends React.Component {
  state = {
    loading: true,
    activated: false,
    error: "",
  };

  componentDidMount() {
    this.fetchActivateAccount();
  }

  fetchActivateAccount = async () => {
    const token = this.props.match?.params?.token;

    if (!token) {
      this.setState({ loading: false, error: "try_later" });
      return;
    }

    try {
      const result = await this.props.ActivateAccount(token);
      if (result.ok) {
        this.setState({ loading: false, activated: true });
      } else {
        this.setState({ loading: false, error: result.error || "try_later" });
        alertify.warning(I18n.t(result.error || "try_later"));
      }
    } catch (error) {
      console.log(error);
      this.setState({ loading: false, error: "try_later" });
    }
  };

  render() {
    const { loading, activated, error } = this.state;

    return (
      <div className="register-success-page">
        <div className="register-success-card">
          <div className={`register-success-card__icon${activated ? "" : " register-success-card__icon--muted"}`}>
            {activated ? "✓" : "!"}
          </div>

          <h1 className="register-success-card__title">
            <Translate value={activated ? "godiway_wellcome" : "warning"} />
          </h1>

          {loading && (
            <p className="register-success-card__text">
              <Translate value="activate_processing" />
            </p>
          )}

          {!loading && activated && (
            <>
              <p className="register-success-card__text">
                <Translate value="godiway_activated_email" />
              </p>
              <Link to="/login" className="register-success-card__button">
                <Translate value="login" />
              </Link>
            </>
          )}

          {!loading && !activated && (
            <>
              <p className="register-success-card__text">
                {I18n.t(error)}
              </p>
              <Link to="/register" className="register-success-card__button register-success-card__button--secondary">
                <Translate value="register" />
              </Link>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  ActivateAccount: (token) => dispatch(actions.activateAccount(token)),
});

export default connect(null, mapDispatchToProps)(GodiwayActivate);
